<header class="app-header flex justify-between items-center">
  <div class="header-content">
    <h1 class="app-title" (click)="goInit()">BiibGo</h1>
    <p class="user-greeting">Hola, <span>{{ userName }}</span></p>
  </div>

  <div class="flex items-center gap-6 relative">
    <button class="notification-btn relative" (click)="abrirDialogoNotificaciones()">
      <mat-icon translate="no" class="notification-icon">notifications</mat-icon>
      <span *ngIf="notificacionesActivas > 0" class="notification-badge">{{ notificacionesActivas }}</span>
    </button>

    <mat-icon translate="no" (click)="abrirDialogoCerrarSesion()" class="logout-icon h-4 w-4 text-base">logout</mat-icon>
  </div>
</header>
<!-- 💬 Template del diálogo de confirmación -->
<ng-template #dialogCerrarSesion>
  <div class="p-5 text-center">
    <!-- <mat-icon color="warn" class="text-lg mb-2">logout</mat-icon> -->
    <h3 class="text-lg font-semibold mb-3">¿Deseas cerrar sesión?</h3>
    <p class="text-gray-600 mb-5">Perderás tu sesión actual y deberás iniciar sesión nuevamente.</p>

    <div class="flex justify-center gap-4">
      <button mat-stroked-button color="primary" (click)="cerrarDialogo()">Cancelar</button>
      <button mat-flat-button color="warn" (click)="confirmarCerrarSesion()">Cerrar sesión</button>
    </div>
  </div>
</ng-template>